module.exports = __webpack_public_path__ + "static/img/3.2e52835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news29/3.png
// module id = hf6K
// module chunks = 1